import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../authentication/authentication.service';
import { LoggingService } from '../logging/logging.service';
import { LazyLoadEvent } from '../../models/DataTables/lazyLoadEvent';
import { Competition, CreateCompetition } from '../../models/inModels/Competition';
import { Observable } from 'rxjs/Observable';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CompetitionService {
  private route = '/api/competitions';
  private entriesRoute = '/api/competitions/entry';
  constructor(
        private http: HttpClient,
        private auth: AuthenticationService,
        private logging: LoggingService
  ) { }

  getPaginatedEntries(competitionId: number, event: LazyLoadEvent): Promise<any>  {
    return this.http.post(`${this.auth.apiUrl}${this.entriesRoute}/search/${competitionId}`,JSON.stringify(event), { headers: this.auth.header })
      .toPromise()
      .then(response => response)
      .catch(error => this.logging.handleError(error));
  }


  downloadMultipleFiles(id: number, take: number): Observable<Blob> {
    const options = { headers : this.auth.header, reportProgress: true, responseType: 'blob' as 'blob' };
    return this.http.get(`${this.auth.apiUrl}${this.route}/download/multiple/files/${id}/${take}`, options);
  }
  
  search(event: LazyLoadEvent): Promise<any> {
      return this.http.post(`${this.auth.apiUrl}${this.route}/search`, JSON.stringify(event), { headers: this.auth.header })
        .toPromise()
        .then(response => response)
        .catch(error => this.logging.handleError(error));
    }


    get(id: number): Promise<Competition> {
      return this.http.get(`${this.auth.apiUrl}${this.route}/get/${id}`, { headers: this.auth.header })
        .toPromise()
        .then(response => response as Competition)
        .catch(error => this.logging.handleError(error));
    }

    create(user: CreateCompetition): Promise<Competition> {
        return this.http.post(`${this.auth.apiUrl}${this.route}/create`, JSON.stringify(user), { headers: this.auth.header })
          .toPromise()
          .then(response => response as Competition)
          .catch(error => this.logging.handleError(error));
      }
    
      delete(id: number): Promise<any> {
        return this.http.get(`${this.auth.apiUrl}${this.route}/delete/${id}`, { headers: this.auth.header })
          .toPromise()
          .then(response => response)
          .catch(error => this.logging.handleError(error));
      }
    
      update(user: CreateCompetition): Promise<Competition> {
        return this.http.post(`${this.auth.apiUrl}${this.route}/update`, JSON.stringify(user), { headers: this.auth.header })
          .toPromise()
          .then(response => response as Competition)
          .catch(error => this.logging.handleError(error));
      }
}



// WEBPACK FOOTER //
// ./src/app/services/competition/competition.service.ts